import React from 'react';
import SurveyResponseChip from './SurveyResponseChip';
import { SurveyResponse } from '../../../../../shared/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBadgeCheck } from '@fortawesome/pro-duotone-svg-icons';
import { Box, Paper, Tooltip, Typography } from '@mui/material';
import { dimGrey, lightBlack, lightPurple } from '../../../../../mainTheme';

interface CSATCardProps {
  data: {
    lastResponse: string;
    // Survey question from the API (`survey_responses[].title`), shown as a
    // tooltip on the title when present.
    title?: string | null;
  };
  isSelected?: boolean;
  onClick?: () => void;
}

const csatOptions = [
  {
    label: 'Very unhappy',
  },
  {
    label: 'Somewhat unhappy',
  },
  {
    label: 'Somewhat happy',
  },
  {
    label: 'Very happy',
  },
];

const CSATCard: React.FC<CSATCardProps> = ({ data, isSelected, onClick }) => {
  return (
    <Paper
      elevation={isSelected ? 8 : 1}
      sx={{
        px: '24px',
        py: '21px',
        cursor: 'pointer',
        transition: 'all 0.3s',
        transform: isSelected ? 'scale(1.02)' : 'none',
        '&:hover': {
          elevation: 3,
        },
        borderRadius: '8px',
        border: isSelected
          ? `1px solid ${lightPurple}`
          : '1px solid var(--Outline-O5---Separator, #D4D4D9)',
        boxShadow: isSelected
          ? '-4px 8px 24px 0px rgba(0, 0, 0, 0.25)'
          : 'none',
        height: '152px',
        flex: '1 0 0',
        overflow: 'hidden',
      }}
      onClick={onClick}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'stretch',
          justifyContent: 'space-between',
        }}
      >
        {/* Left section: title+icon, then legend */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
          }}
          justifyContent="space-between"
        >
          <Tooltip title={data.title ?? ''} placement="top" arrow>
            <Box sx={{ display: 'flex', width: 'fit-content' }}>
              <Typography
                sx={{
                  color: isSelected ? lightBlack : dimGrey,
                  fontSize: '16px',
                  fontWeight: 700,
                  letterSpacing: '0.2px',
                  mr: 1,
                }}
              >
                CSAT
              </Typography>
              <FontAwesomeIcon
                icon={faBadgeCheck}
                color={isSelected ? lightPurple : dimGrey}
                fontSize={22}
              />
            </Box>
          </Tooltip>
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-end',
            }}
          >
            {csatOptions.map((opt) => {
              const isCurrent = data.lastResponse === opt.label;
              return (
                <SurveyResponseChip
                  key={opt.label}
                  response={opt.label as SurveyResponse}
                  isCurrent={isCurrent}
                  style={{ marginBottom: '4px' }}
                  highlightBorder
                />
              );
            })}
          </div>
        </Box>
      </Box>
    </Paper>
  );
};

export default CSATCard;
